var resetStorage = function (key, newVal) {
   if (key === 'watchStorage') {
       var newStorageEvent = document.createEvent('StorageEvent');
       const storage = {
           setItem: function (k, val) {
               sessionStorage.setItem(k, val);
               newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
               window.dispatchEvent(newStorageEvent)
           }
       }
       return storage.setItem(key, newVal);
   }
}
export default resetStorage;


// WEBPACK FOOTER //
// ./src/store/resetStorage.js